@if (parcel) {
  <div class="flex flex-col flex-auto w-full p-4 xs:p-2">
    <div class="flex flex-wrap w-full">
      <div class="flex items-center justify-between w-full mb-4 px-4 xs:pr-0">
        <div class="mr-6">
          <h2 class="m-0">{{ property?.name || property?.address?.address_string || '' }}</h2>
          <div class="text-secondary tracking-tight">Tax records, title, mortgage and ownership information.</div>
        </div>
      </div>
      <div class="flex flex-wrap w-1/2 lt-xl:w-full flex-col">
        <div class="flex flex-col bg-card shadow-md rounded overflow-hidden">
          <div class="flex flex-col p-4 pl-6">
            <div class="flex items-center justify-between">
              <div class="flex flex-col">
                <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">Tax Assessor</div>
                <div class="text-sm text-hint font-medium">Tax assessor records.</div>
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-start text-md px-6 pb-3">
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Lot Size</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.areaLotAcres | number: '1.2-2' }} acres</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Zoning</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.zonedCodeLocal }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">APN</div>
              <div class="w-1/2">{{ parcel.parcel?.apn }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Year Built</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.yearBuilt }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium"># Units</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.unitsCount }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Building SF</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.areaBuilding | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Gross SF</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.areaLotSf | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Tax Rate</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.taxRateArea | number: '1.0-0' }}%</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Tax Bill</div>
              <div class="w-1/2">
                ${{ parcel.taxAssessor?.taxBilledAmount | number: '1.0-0' }} ({{ parcel.taxAssessor?.taxYearAssessed }})
              </div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Last Sale Date</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.assessorLastSaleDate }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Last Sale Amount</div>
              <div class="w-1/2">${{ parcel.taxAssessor?.assessorLastSaleAmount | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Asset Type</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.zonedCodeLocal }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">County</div>
              <div class="w-1/2">{{ parcel.taxAssessor?.situsCounty }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Assessed Land Value</div>
              <div class="w-1/2">${{ parcel.taxAssessor?.taxAssessedValueLand | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Assessed Total Value</div>
              <div class="w-1/2">${{ parcel.taxAssessor?.taxAssessedValueTotal | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Market Land Value</div>
              <div class="w-1/2">${{ parcel.taxAssessor?.taxMarketValueLand | number: '1.0-0' }}</div>
            </div>
            <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
              <div class="flex items-center w-1/2 font-medium">Market Total Value</div>
              <div class="w-1/2">${{ parcel.taxAssessor?.taxMarketValueTotal | number: '1.0-0' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-auto w-1/2 min-w-80 pl-4 flex-col">
        <div class="flex flex-col bg-card shadow-md rounded overflow-hidden mt-4">
          <div class="flex flex-col p-4 pl-6">
            <div class="flex items-center justify-between">
              <div class="flex flex-col">
                <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">Owner Records</div>
                <div class="text-sm text-hint font-medium">Ownership records for property.</div>
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-start text-md px-6 pb-3">
            <div class="flex items-center justify-between py-3 border-b last:border-b-0">
              <div class="flex items-center w-1/2 font-medium">Deed Owner 1</div>
              <div class="w-1/2">
                <p>
                  {{ parcel?.taxAssessor?.deedOwner1NameFull }}
                </p>
              </div>
            </div>

            <div class="flex items-center justify-between py-3 border-b last:border-b-0">
              <div class="flex items-center w-1/2 font-medium">Deed Owner 2</div>
              <div class="w-1/2">
                <p>
                  {{ parcel?.taxAssessor?.deedOwner2NameFull }}
                </p>
              </div>
            </div>

            <div class="flex items-center justify-between py-3 border-b last:border-b-0">
              <div class="flex items-center w-1/2 font-medium">Deed Owner 3</div>
              <div class="w-1/2">
                <p>
                  {{ parcel?.taxAssessor?.deedOwner3NameFull }}
                </p>
              </div>
            </div>

            <div class="flex items-center justify-between py-3 border-b last:border-b-0">
              <div class="flex items-center w-1/2 font-medium">Deed Owner 4</div>
              <div class="w-1/2">
                <p>
                  {{ parcel?.taxAssessor?.deedOwner4NameFull }}
                </p>
              </div>
            </div>

            <div class="flex items-center justify-between py-3 border-b last:border-b-0">
              <div class="flex items-center w-1/2 font-medium">Contact Owner Mailing Address</div>
              <div class="w-1/2">
                <p>
                  {{ parcel?.taxAssessor?.contactOwnerMailAddressFull }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col bg-card shadow-md rounded overflow-hidden mt-4">
          <div class="flex flex-col p-4 pl-6">
            <div class="flex items-center justify-between">
              <div class="flex flex-col">
                <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">School Data</div>
                <div class="text-sm text-hint font-medium">School records for address.</div>
              </div>
            </div>
          </div>

          @if (parcel?.schools) {
            <div class="flex flex-col ustify-start text-md px-6 pb-3">
              @for (school of parcel.schools; track $index) {
                <div class="flex items-center justify-between py-3 border-b last:border-b-0">
                  <div class="flex items-center w-1/3 font-medium">
                    {{ school?.instructionalLevel || 'N/A' }}
                  </div>
                  <div class="w-1/3">{{ school?.schoolNm || 'N/A' }}</div>
                  <div class="w-1/3">
                    <span
                      class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
                      [ngClass]="[
                        school.schoolRating?.includes('A') ? 'green-100' : '',
                        school.schoolRating?.includes('B') ? 'green-100' : '',
                        school.schoolRating?.includes('C') ? 'orange-100' : '',
                        school.schoolRating?.includes('D') ? 'red-300' : '',
                        school.schoolRating?.includes('E') ? 'red-300' : '',
                        school.schoolRating?.includes('F') ? 'red-300' : '',
                      ]"
                    >
                      <span class="leading-relaxed whitespace-nowrap">{{ school?.schoolRating || 'N/A' }}</span>
                    </span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
